import { EventHandler } from "../event/EventHandler";
import { Delay } from "./Delay";
/**
 * Timer.ts
 */
export class Timer {
    constructor(delay, repeatCount = 0) {
        this.reset(delay, repeatCount);
    }
    /**
     * `action` gets called when the timer has done `repeatCount` iterations.
     */
    onComplete(action, scope) {
        this.completeHandler = new EventHandler(action, scope);
    }
    /**
     * `action` gets called every time the timer does an iteration.
     */
    onUpdate(action, scope) {
        this.updateHandler = new EventHandler(action, scope);
    }
    /**
     * Creates a `Delay` that will eventually trigger the attached callbacks.
     */
    start() {
        if (this.isRunning())
            return;
        this.running = true;
        this.id = Delay.create(this.delay, this.handler, this);
    }
    /**
     * Stops the timer and resets `repeatCount`.
     */
    stop() {
        this.currentCount = 0;
        this.running = false;
        this.id?.dispose();
    }
    /**
     * Reuse this timer's callbacks with a new `delay` and `repeatCount`.
     */
    reset(delay, repeatCount = 0) {
        this.stop();
        this.delay = delay;
        this.repeatCount = repeatCount;
        this.handler = this.handleTimerUpdate.bind(this);
    }
    handleTimerUpdate() {
        if (!this.isRunning())
            return;
        this.currentCount++;
        if (this.repeatCount > 0 && this.currentCount == this.repeatCount) {
            this.stop();
            this.callHandler(this.completeHandler);
            return;
        }
        this.callHandler(this.updateHandler);
        this.id = Delay.create(this.delay, this.handler, this);
    }
    callHandler(handler) {
        if (handler) {
            handler.call(this);
        }
    }
    getCurrentCount() {
        return this.currentCount;
    }
    isRunning() {
        return this.running;
    }
}
//# sourceMappingURL=Timer.js.map